import { render } from "./createDealerGroupForm.vue?vue&type=template&id=12cf9edc&scoped=true"
import script from "./createDealerGroupForm.vue?vue&type=script&lang=js"
export * from "./createDealerGroupForm.vue?vue&type=script&lang=js"

import "./createDealerGroupForm.vue?vue&type=style&index=0&id=12cf9edc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cf9edc"]])

export default __exports__